// Id starts or ends with letter in lower case or number. Id can contain - and _, but in single mode.
export const projectIdRegex = /^[a-z0-9][a-z0-9]*(?:[_-][a-z0-9]+)*$/
